import { Button } from "@/components/ui/button";
import { Trophy } from "lucide-react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";
import { useCmsSection } from "@/hooks/useCmsSection";

const QuizBanner = () => {
  const { lang } = useI18n();
  const cms = useCmsSection("quiz");

  const quizLabel = lang === "ar" ? "🎯 اختبار سياسي" : lang === "zgh" ? "🎯 ⴰⵙⵉⵜⴳ ⴰⵙⵔⵜⴰⵏ" : "🎯 Quiz Politique";
  const quizSub = lang === "ar" ? <strong className="font-bold">لخصنا لك الخطوط العريضة. جرب هذا الاختبار القصير لتعرف أين تكمن تقاطعاتك.</strong> : lang === "zgh" ? <strong className="font-bold">ⵏⵙⴳⵣⵍ ⴰⴽ ⵉⵣⵔⵉⵔⵏ ⵉⵎⵇⵕⴰⵏⵏ. ⴰⵔⵎ ⴰⵙⵉⵜⴳ ⴰⴷ ⴰⴼⴰⴷ ⴰⴷ ⵜⵙⵙⵏⴷ ⵎⴰⵏⵉ ⵖⴰ ⵜⴰⴼⴷ ⵉⵅⴼ ⵏⵏⴽ.</strong> : <strong className="font-bold">On a résumé les grandes lignes pour vous. Prêtez-vous au jeu du quiz en quelques questions pour voir où se situent vos affinités.</strong>;

  const displayTitle = lang === 'ar' ? (cms.title_ar || quizLabel) : (cms.title_fr || quizLabel);
  const displaySubtitle = lang === 'ar' ? (cms.subtitle_ar || quizSub) : (cms.subtitle_fr || quizSub);
  const displayBtn = lang === 'ar' ? (cms.btn_ar || null) : (cms.btn_fr || null);

  return (
    <section id="quiz" className="py-6 bg-gradient-to-r from-primary/10 via-accent/10 to-secondary/10">
      <div className="container text-center space-y-4">
        {cms.title_fr || cms.title_ar ? (
          <h2 className="text-2xl font-display font-extrabold text-foreground">{displayTitle}</h2>
        ) : null}
        <p className="text-muted-foreground font-body">{displaySubtitle}</p>
        <Button size="lg" className="w-full sm:w-auto h-auto min-h-[3.5rem] whitespace-normal text-base sm:text-xl px-4 sm:px-12 py-4 sm:py-7 font-display font-extrabold gap-2 sm:gap-3 shadow-[var(--shadow-elevated)]" asChild>
          <Link to="/quiz">
            <Trophy className="w-6 h-6" />
            {displayBtn || displayTitle}
          </Link>
        </Button>
      </div>
    </section>
  );
};

export default QuizBanner;
